import React from 'react';
import { Typography } from '@mui/material';

const TITLE = 'AI Workforce Command Center';

const Agents = () => <Typography variant="h5">{TITLE} - To Be Developed</Typography>;

export default Agents;
